<template>
  <v-container style="max-width: 1280px">
    <v-row justify="center">
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-card-subtitle>
          Step 2 / 5
        </v-card-subtitle>
        <v-progress-linear height="10" :value="progress" striped></v-progress-linear>
      </v-card>
    </v-col>
  </v-row>
    <!-- User Inputs -->
    <v-row justify="center" v-if="state == 0">
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="justify-center">
            First Life Pie
          </v-card-title>
          <v-card-subtitle class="text-center">
            Below are three sliders representing <span style="color: #EF5350">bad</span>, <span style="color: #66BB6A">ok</span>, and <span style="color: #42A5f5">good</span>.<br>
            Use them to represent how you feel about your major issue.<br>
            (100 Points Max)
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text class="black--text text-center">
            <v-container>
              <v-row>
                <v-col>
                  <vue-slider
                    class="bad-slider"
                    v-model="sliders[0]"
                    dotSize="32"
                    height="32px"
                    :interval="5"
                    :process="get_bad_style"
                    :tooltipStyle="{backgroundColor: '#EF5350'}"
                    @change="update_chart"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <vue-slider
                    class="ok-slider"
                    v-model="sliders[1]"
                    dotSize="32"
                    height="32px"
                    :interval="5"
                    :process="get_ok_style"
                    :tooltipStyle="{backgroundColor: '#66BB6A'}"
                    @change="update_chart" 
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <vue-slider
                    class="good-slider"
                    v-model="sliders[2]"
                    dotSize="32"
                    height="32px"
                    :interval="5"
                    :process="get_good_style"
                    :tooltipStyle="{backgroundColor: '#42A5F5'}"
                    @change="update_chart" 
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="d-flex justify-center">
                  <v-chip :color="color_from_points(total_points)" dark>
                    {{ 100 - total_points }} Points Remaining
                  </v-chip>
                </v-col>
              </v-row>
              <v-row justify="center" v-if="total_points != 100">
                <v-col>
                  <v-alert type="error" class="mb-0">
                    You must use exactly 100 points.
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Pie Chart View-->
    <v-row justify="center" v-if="total_points == 100">
      <v-col cols="12" md="6">
        <pie-chart
          :title="title"
          :data="chart_data"
        />
      </v-col>
    </v-row>

    <v-row justify="center" v-if="total_points == 100">
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="justify-center">
            Your Results
          </v-card-title>
          <v-card-subtitle class="text-center">
            Does this accurately represent how you feel about your major issue?<br>
            If not, you can change the values.
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-alert class="mb-0" color="deep-orange" type="info">
            {{ major_issue.issue.message_first }}
            </v-alert>
            <christian-alert
              v-if="major_issue.christian"
              :message="major_issue.issue.christian_first"
              :major_issue="major_issue.issue.major_issue"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="total_points == 100">
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-actions class="justify-center pa-3">
            <v-btn class="mr-2" color="secondary" @click="state = 0">
              Restart
            </v-btn>
            <v-btn color="primary" :disabled="total_points != 100" @click="finish">
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
/*  Bad Slider */
.bad-slider .vue-slider-dot-handle {
  background-color: #ffffff;
  border: 2px solid #ee7d7b;
}

.bad-slider .vue-slider-dot-tooltip-inner {
  border-color: #EF5350;
}

.bad-slider .vue-slider-dot-handle-focus {
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.25);
}

/*  Ok Slider */
.ok-slider .vue-slider-dot-handle {
  background-color: #ffffff;
  border: 2px solid #66BB6A;
}

.ok-slider .vue-slider-dot-tooltip-inner {
  border-color: #66BB6A;
}

.ok-slider .vue-slider-dot-handle-focus {
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.25);
}

/*  Good Slider */
.good-slider .vue-slider-dot-handle {
  background-color: #ffffff;
  border: 2px solid #42A5F5;
}

.good-slider .vue-slider-dot-tooltip-inner {
  border-color: #42A5F5;
}

.good-slider .vue-slider-dot-handle-focus {
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.25);
}
</style>

<script>
  import PieChart from "../components/PieChart.vue";
  import ChristianAlert from '../components/ChristianAlert.vue';

  export default {
    name: 'InitialPie',
    components: {
      PieChart,
      ChristianAlert
    },
    data: () => ({
      // State
      state: 0,

      major_issue: {},

      // Pie chart.
      title: 'My First Pie',
      headers: ['Answer', 'Value'],
      data: [
          ['Bad',     0],
          ['Ok',      0],
          ['Good',    0],
          ['Unused',  100]
      ],

      // Sliders
      sliders: [
        0,0,0
      ]

    }),
    computed: {
      progress: function() {
        return this.total_points == 100 ? 50 : 25;
      },

      // Chart data accessor.
      chart_data() {
        return [this.headers, ...this.data]
      },

      // Total points as the sum of all three sliders.
      total_points() {
        return this.sliders[0] + this.sliders[1] + this.sliders[2];
      },

      // Gets the sliders values as well as the unused difference.
      slider_values() {
        return [
          ...this.sliders,
          this.clamp(100 - this.total_points, 0, 100)
        ]
      },

      // Gets the slider values as a percentage.
      percentage_values: function () {
        return {
          bad:  this.sliders[0] / 100,
          ok:   this.sliders[1] / 100,
          good: this.sliders[2] / 100
        };
      }
    },
    methods: {
      // Bar styles.
      get_bad_style: function(dotsPos) {
        return [[0, dotsPos[0], { backgroundColor: "#EF5350" }]]
      },

      get_ok_style: function(dotsPos) {
        return [[0, dotsPos[0], { backgroundColor: "#66BB6A" }]]
      },

      get_good_style: function(dotsPos) {
        return [[0, dotsPos[0], { backgroundColor: "#42A5F5" }]]
      },

      color_from_points: function(total) {
        if (total > 100) {
          return 'red lighten-1';
        }
        else if (total == 100) {
          return 'blue lighten-1';
        }
        else {
          return 'grey darken-2';
        }
      },

      clamp: function(v, min, max) {
        return Math.min(Math.max(v, min), max);
      },

      update_chart: function() {
        if (this.total_points != 100) {
          this.data = [
            ['Bad',     0],
            ['Ok',      0],
            ['Good',    0],
            ['Unused',  100]
          ];
          return;
        }

        var slider_values = this.slider_values;
        this.data = this.data.map((row, dataIndex) => {
          return row.map((item, index) => {
            if (index == 0) return item;
            return slider_values[dataIndex];
          })
        })
      },

      finish: function() {
        var query = this.$route.query;
        var values = JSON.stringify({
          bad: this.sliders[0],
          ok: this.sliders[1],
          good: this.sliders[2]
        });
        this.$router.push({
          path: 'general',
          query: {
            major_issue: query.major_issue,
            initial: values
          }
        });
      }
    },
    mounted() {
      this.major_issue = JSON.parse(this.$route.query.major_issue);
    }
  }
</script>